// removed by extract-text-webpack-plugin
module.exports = {"issueDetails":"Gf13ff5","button":"Gc96d88"};